import { SpinnerBase } from '@moment/design-system-ui/spinner'

const LoadingIcon = () => (
  <div className="flex items-center justify-center">
    <SpinnerBase className="size-6 text-text-secondary" />
  </div>
)

export { LoadingIcon }
